export default "/images/3546d527dd1be74e533cee745ea5db54.avif";